// frontend/src/components/Admin/adminpage.js

import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Sidebar from "./sidebar";
import Navbar from "./navigation";
import AdminFooter from "./adminfooter";
import AdminCards from "./admincards";
import UsersDetails from "./userdetails";
import AdminDetails from "./admindetails";
import DeviceDetails from "./devicedetails";
// import AlertsPage from "./alertpage";
import AdminAlertsPage from './AdminAlertsPage'; 
import PatientDetails from "./patientdetails"; // ✅ Import PatientDetails component
// import webSocketService from "./websocket";
// import { addNotification } from "../../redux/slices/NotificationSlice";
import './AdminCSS/admin.css';
import BluetoothWiFiConnect from "./BluetoothWiFiConnect";


const AdminPage = () => {
  const [currentPage, setCurrentPage] = useState("dashboard");
  const dispatch = useDispatch();

  // useEffect(() => {
  //   webSocketService.connect("ws://sens-able.manipal.net:8000/ws/notifications");

  //   webSocketService.onMessage((notification) => {
  //     console.log('handler received data:', notification);
  //     dispatch(addNotification(notification));
  //   });

  //   return () => {
  //     webSocketService.disconnect();
  //   };
  // }, [dispatch]);

  const renderBodyContent = () => {
    switch (currentPage) {
      case "dashboard":
        return <AdminCards onNavigate={setCurrentPage} />;
      case "users":
        return <UsersDetails />;
      case "admins":
        return <AdminDetails />;
      case "devices":
        return <DeviceDetails />;
      case "patients":
        return <PatientDetails />;
      case "bluetooth-wifi-connect":
        return <BluetoothWiFiConnect />;  // ✅ Render patient details
      case 'admin-alerts':
        return <AdminAlertsPage />;
      // case "fall-alerts":
      //   return <AlertsPage />;
      default:
        return <AdminCards onNavigate={setCurrentPage}  />;
    }
  };

  return (
    <div className="main-content">
      <Sidebar onOptionClick={setCurrentPage} />
      <Navbar />
      <header className="admin-header">
        <h1>
          {currentPage === "dashboard"
            ? "Admin Dashboard"
            : currentPage === "users"
            ? "Users"
            : currentPage === "admins"
            ? "Admins"
            : currentPage === "devices"
            ? "Devices"
            : currentPage === "patients"
            ? "Patients"
            : currentPage === "bluetooth-wifi-connect"
            ? "Patients"
            // : currentPage === "fall-alerts"
            // ? " Fall Alerts"
            : currentPage === "admin-alerts"
            ? "Alerts"
            : "Page Not Found"}
        </h1>
      </header>
      {renderBodyContent()}
      <AdminFooter />
    </div>
  );
};

export default AdminPage;